var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H0.5V7.5H7.5V0.5ZM6.5 6.5H1.5V1.5H6.5V6.5Z",
    fill: "#002E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H9V7.5H16V0.5ZM15 6.5H10V1.5H15V6.5Z",
    fill: "#002E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5H24.5V0.5H17.5V7.5ZM18.5 1.5H23.5V6.5H18.5V1.5Z",
    fill: "#002E6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9H0.5V16H7.5V9ZM6.5 15H1.5V10H6.5V15Z",
    fill: "#002E6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H16V9H9V16ZM10 10H15V15H10V10Z",
    fill: "#002E6E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16H24.5V9H17.5V16ZM18.5 10H23.5V15H18.5V10Z",
    fill: "#002E6E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5H0.5V24.5H7.5V17.5ZM6.5 23.5H1.5V18.5H6.5V23.5Z",
    fill: "#002E6E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.5H16V17.5H9V24.5ZM10 18.5H15V23.5H10V18.5Z",
    fill: "#002E6E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.5H24.5V17.5H17.5V24.5ZM18.5 18.5H23.5V23.5H18.5V18.5Z",
    fill: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/listView.4e11cae1b8ab707d124786aeb6bda3b2.svg";
export { ForwardRef as ReactComponent };